import tiktokGlyph from '@/assets/images/home/tiktok.svg'
import instagramGlyph from '@/assets/images/home/instagram.svg'
import instagramCircle from '@/assets/images/home/instagram-circle.png'
import scanBarcodeIcon from '@/assets/3d-assets/icons/search-barcode.png'
import sparkleScanIcon from '@/assets/3d-assets/icons/magic-scan.png'
import priceTagIcon from '@/assets/3d-assets/icons/dollar-bookmark.png'
import cardSearchIcon from '@/assets/3d-assets/icons/search-database.png'
import batteryIcon from '@/assets/3d-assets/icons/power.png'

export const PAGE_ALERT = {
  /**
   * theme will change based on the view of alert
   * for now I set styles to toggle between only two themes: primary - error
   */
  // theme: 'primary',
  theme: 'error',
  text: 'You have used all of your AI Credits for this month on your current plan. Please consider upgrading your plan or purchasing additional AI Credits.',
  // text: 'We can’t process your recent payment. Please add a new payment method in billing settings.',
  route: '/settings/plans'
}

export const GETTING_STARTED_STEPS = [
  {
    name: 'created-account',
    done: true,
    title: 'Create a CDP account'
  },
  {
    name: 'downloaded-app',
    done: false,
    title: 'Download CDP desktop app',
    video: {
      src: 'https://framerusercontent.com/modules/assets/BsaiKBpZRVZLmqgZcQ32w5jCbY~R60Ht26im7Xhmk0tVg3vUBkRef4lgnu0xh7d7bzINz4.mp4',
      poster: 'https://i.ytimg.com/vi_webp/Ffp49I2_hm4/maxresdefault.webp',
    },
    description: `Download the CDP desktop app to help you speed up your scanning process.`,
    route: '/',
    routeText: 'Download App',
    canSkip: true,
  },
  {
    name: 'created-batch',
    done: false,
    title: 'Create a new batch and import items',
    video: {
      src: 'https://framerusercontent.com/modules/assets/BsaiKBpZRVZLmqgZcQ32w5jCbY~R60Ht26im7Xhmk0tVg3vUBkRef4lgnu0xh7d7bzINz4.mp4',
      poster: 'https://i.ytimg.com/vi_webp/Ffp49I2_hm4/maxresdefault.webp',
    },
    description: `Create your first batch by uploading the image scans or manually searching our database.`,
    route: '/create-batch/general-settings',
    routeText: 'Create a New Batch',
    canSkip: false,
  },
  {
    name: 'prepared-export',
    done: false,
    title: 'Prepare items for export',
    video: {
      src: 'https://framerusercontent.com/modules/assets/BsaiKBpZRVZLmqgZcQ32w5jCbY~R60Ht26im7Xhmk0tVg3vUBkRef4lgnu0xh7d7bzINz4.mp4',
      poster: 'https://i.ytimg.com/vi_webp/Ffp49I2_hm4/maxresdefault.webp',
    },
    description: `Go through the missing details and suggested edits in the batch detail spreadsheet or inspector view to quickly prepare your items for export.`,
    route: '/batches',
    routeText: 'Complete this step',
    canSkip: false,
  },
  {
    name: 'added-connection',
    done: false,
    title: 'Add marketplace connection',
    video: {
      src: 'https://framerusercontent.com/modules/assets/BsaiKBpZRVZLmqgZcQ32w5jCbY~R60Ht26im7Xhmk0tVg3vUBkRef4lgnu0xh7d7bzINz4.mp4',
      poster: 'https://i.ytimg.com/vi_webp/Ffp49I2_hm4/maxresdefault.webp',
    },
    description: `Connect to the eBay channel and follow the steps to configure your export settings. These one-time settings will help you streamline your export experience later. More marketplace connections will be available soon.`,
    route: '/connections',
    routeText: 'Go to Connections',
    canSkip: false,
  },
  {
    name: 'created-export',
    done: false,
    title: 'Export items to marketplaces',
    video: {
      src: 'https://framerusercontent.com/modules/assets/BsaiKBpZRVZLmqgZcQ32w5jCbY~R60Ht26im7Xhmk0tVg3vUBkRef4lgnu0xh7d7bzINz4.mp4',
      poster: 'https://i.ytimg.com/vi_webp/Ffp49I2_hm4/maxresdefault.webp',
    },
    description: `Once all items are ready to list, click on “Export” and follow the steps to export your listings.`,
    route: '/batches/85058',
    routeText: 'Complete this step',
    canSkip: false,
  }
]

// Route names that are the dealer's home: the referral bubble shows there, the reactivate-account overlay stays
// off it and the sidebar opens there by default. `Homepage` is the new Home at `/`; legacy-design dealers keep the
// previous one at `/legacy-home`.
// TODO(before-prod): drop 'LegacyHome' when the /legacy-home route goes.
export const HOME_ROUTE_NAMES = ['Homepage', 'LegacyHome']

// The Home API's `home_state`: a new user has no cards in inventory, an active user has at least one; the page switches its layout on it.
export const HOME_STATES = Object.freeze({
  NEW: 'new',
  ACTIVE: 'active',
})

// The shared recent-batches slot holds this many of the batches the dealer worked on last: the Inventory strip fills a row from it, Home shows 5 and the sidebar 3.
export const HOME_RECENT_BATCHES_LIMIT = 16

// Home "Pick up where you left off" shows this many of them.
export const HOME_RECENT_BATCHES_SHOWN = 5

// Home "Overview" tiles, in the design's order, from `/insights/snapshot` over this range (one of INSIGHTS_PERIODS).
// The API sends each tile's value, trend and caption; `key` is its field in the answer.
export const HOME_OVERVIEW_RANGE = 'last_30_days'

export const HOME_OVERVIEW_STATS = [
  { key: 'total_cards', title: 'Total Cards' },
  { key: 'total_sales', title: 'Total Sales' },
  { key: 'active_listings', title: 'Active Listings' },
  { key: 'pending_orders', title: 'Pending Orders' },
]

// Home "Quick actions": the flows a dealer reaches for most, each tile one link; static until the Home API serves them. `glyph` names one of CDP's own inline icons in helpers/icons.js, `icon` an Iconify name. All four always show, whatever the dealer's Getting Started progress.
export const HOME_QUICK_ACTIONS = [
  { key: 'create-batch', title: 'Create a batch', glyph: 'blank_batch', to: '/create-batch' },
  { key: 'connect-marketplaces', title: 'Connect marketplaces', icon: 'heroicons-outline:link', to: '/connections' },
  { key: 'card-templates', title: 'Card templates', icon: 'heroicons-outline:template', to: '/settings/templates' },
  { key: 'pick-orders', title: 'Pick recent orders', icon: 'heroicons-outline:shopping-cart', to: '/sale-pick-list' },
]

// Home "Guides" row: static until the Home content API serves it. Each card opens its support article.
// `cover` is the card's playbook picture: a one-hue gradient (`tone`), a 3D icon on a white tile (`glyph` is where the
// icon's visible part sits in its PNG — left, top, width, height as fractions — so the soft-shadow margin is cropped),
// the short name, and a page of the guide — a taped `note` or a stack of book `pages`.
export const HOME_GUIDES = [
  {
    title: 'Choosing the right card scanner',
    href: 'https://support.carddealerpro.com/hc/en-us/articles/21789296752539-Tested-and-Supported-Scanners-Trading-Card-Scanner-Application',
    cover: { tone: 'cdp', icon: scanBarcodeIcon, glyph: [0.265, 0.217, 0.47, 0.47], label: 'Scanners', paper: 'note', tip: 'See which scanners CDP has tested.', items: ['Tested models', 'Speed & feeder', 'Your desk setup'] },
  },
  {
    title: 'Install scanning software for your setup',
    href: 'https://support.carddealerpro.com/hc/en-us/articles/21789941787931-Trading-Card-Scanner-How-to-Install-on-Windows',
    cover: { tone: 'green', icon: sparkleScanIcon, glyph: [0.211, 0.172, 0.579, 0.579], label: 'Software', paper: 'pages', tip: 'Set up the scanner app on Windows.', items: ['Download', 'Install', 'Scan a test card'] },
  },
  {
    title: 'Creating your first eBay Marketplace template',
    href: 'https://support.carddealerpro.com/hc/en-us/articles/47759014416155-eBay-Set-Up-a-Marketplace-Template-in-Card-Dealer-Pro',
    cover: { tone: 'orange', icon: priceTagIcon, label: 'Templates', paper: 'pages', tip: 'Templates to control how cards get listed.', items: ['eBay category', 'Listing behavior', 'Business policies'] },
  },
  {
    // The nearest article the support center has for this title.
    title: 'What types of cards does Card Dealer Pro support?',
    href: 'https://support.carddealerpro.com/hc/en-us/articles/49746276013211-How-Card-Dealer-Pro-Adds-New-Card-Sets-to-the-Database',
    cover: { tone: 'blue', icon: cardSearchIcon, glyph: [0.211, 0.172, 0.579, 0.579], label: 'Card types', paper: 'pages', tip: 'How new sets reach the card database.', items: ['Sports', 'Trading card games', 'Non-sport'] },
  },
  {
    title: 'Understanding how AI credits work',
    href: 'https://support.carddealerpro.com/hc/en-us/articles/20929845276187-Plans-AI-Credits',
    cover: { tone: 'purple', icon: batteryIcon, label: 'AI credits', paper: 'pages', tip: 'How AI credits work with your plan.', items: ['What uses credits', 'Your balance', 'Plans'] },
  },
]

// Home "CDP Hub" tag badges: the design's colour for each of its four tags (its blue is the brand blue the Get started cards' badges use); a tag the CMS adds beyond them is gray.
export const CDP_HUB_TAG_VARIANTS = {
  'Get started': 'tint-light',
  'Marketplaces': 'yellow',
  'Inventory Management': 'orange',
  'Listings & Orders': 'purple',
}

// CDP Hub page: posts per page of "All articles".
export const CDP_HUB_PER_PAGE = 10

// Home "Community" row: the networks in the design's order, each opening in a new tab; static until the Home content API serves it.
export const HOME_COMMUNITY = [
  {
    // The design's own glyph: the on-dark TikTok mark (white note, cyan and red offsets); Iconify only has the black-note one.
    name: 'Tiktok',
    href: 'https://www.tiktok.com/@carddealer_pro',
    image: tiktokGlyph,
    iconClass: 'h-[18px] w-4',
    circleClass: 'bg-black',
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/carddealerpro',
    icon: 'basil:facebook-solid',
    iconClass: 'size-5',
    circleClass: 'bg-[#1877F2]',
  },
  {
    // The design's own glyph over its gradient picture (a 740px stock image, scaled to 64px for the 32px circle).
    name: 'Instagram',
    href: 'https://www.instagram.com/carddealer_pro/',
    image: instagramGlyph,
    iconClass: 'size-5',
    circleImage: instagramCircle,
  },
  {
    name: 'Linkedin',
    href: 'https://www.linkedin.com/company/card-dealer-pro',
    icon: 'akar-icons:linkedin-fill',
    iconClass: 'size-5',
    circleClass: 'bg-[#0A66C2]',
  },
  {
    name: 'X',
    href: 'https://twitter.com/CardDealer_Pro',
    icon: 'bi:twitter-x',
    iconClass: 'size-4',
    circleClass: 'bg-black',
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@CardDealerPro',
    icon: 'akar-icons:youtube-fill',
    iconClass: 'size-[18px]',
    circleClass: 'bg-[#FF0302]',
  },
]
